import React from 'react';
import { Card } from '../ui/card';
import { HardDrive, File, Folder, Archive, Users } from 'lucide-react';
import { mockDrive } from '../../mock';

const DriveWidget = () => {
  const getFileIcon = (type) => {
    switch (type) {
      case 'presentation':
        return <File className="text-orange-400" size={20} />;
      case 'folder':
        return <Folder className="text-indigo-400 dark:text-violet-400" size={20} />;
      case 'archive':
        return <Archive className="text-purple-400" size={20} />;
      default:
        return <File className="text-[#9ca3af] dark:text-[#555]" size={20} />;
    }
  };

  return (
    <Card className="bg-white/75 backdrop-blur-md border border-white/90 shadow-[0_4px_20px_rgba(99,102,241,0.06)] dark:bg-[#111114] dark:border-[#1e1e24] dark:shadow-none hover:shadow-[0_8px_30px_rgba(99,102,241,0.1)] dark:hover:shadow-none transition-all duration-300 overflow-hidden">
      <div className="p-6">
        {/* Header */}
        <div className="flex items-center justify-between mb-4 pb-4 border-b border-indigo-50/50 dark:border-[#1a1a20]">
          <div className="flex items-center space-x-3">
            <div className="p-2 bg-[rgba(99,102,241,0.08)] dark:bg-[rgba(167,139,250,0.1)] rounded-xl">
              <HardDrive className="text-indigo-500 dark:text-violet-400" size={24} />
            </div>
            <h2 className="text-xl font-semibold text-[#1a1625] dark:text-[#e5e5e5]">Drive</h2>
          </div>
        </div>

        {/* Drive List */}
        <div className="space-y-2 max-h-[400px] overflow-y-auto custom-scrollbar">
          {mockDrive.map((item) => (
            <div
              key={item.id}
              className="p-4 bg-gradient-to-br from-indigo-50/30 to-white dark:from-[#16161b] dark:to-[#111114] rounded-xl hover:shadow-md transition-all duration-200 cursor-pointer border border-indigo-50/80 dark:border-[#1a1a20]"
            >
              <div className="flex items-start space-x-3">
                <div className="flex-shrink-0">{getFileIcon(item.type)}</div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium text-[#1a1625] dark:text-[#e5e5e5] truncate">
                    {item.name}
                  </p>
                  <div className="flex items-center space-x-2 mt-1">
                    <p className="text-xs text-[#9ca3af] dark:text-[#555]">{item.size}</p>
                    <span className="text-[#9ca3af] dark:text-[#333]">•</span>
                    <p className="text-xs text-[#9ca3af] dark:text-[#555]">
                      {item.modifiedAt.toLocaleDateString('en-US', {
                        month: 'short',
                        day: 'numeric',
                      })}
                    </p>
                  </div>
                  {item.sharedWith.length > 0 && (
                    <div className="flex items-center space-x-1 mt-2">
                      <Users size={12} className="text-indigo-300 dark:text-[#555]" />
                      <span className="text-xs text-[#9ca3af] dark:text-[#555]">
                        Shared with {item.sharedWith.length}
                      </span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Card>
  );
};

export default DriveWidget;
